<div class="create-sign-stepper bulk-sign-stepper create-sign-stepper--hide-mat-headers"
  [class.on-review]="stepper?.selectedIndex === 2">
  <div class="create-sign-stepper__card" #stepContentContainer>
    <mat-stepper
      linear
      #stepper
      labelPosition="bottom"
      class="create-sign-stepper__mat-stepper"
      [class.thank-you-step]="stepper?.selectedIndex === 3"
      (selectionChange)="onStepperSelectionChange($event)">

      <ng-template matStepperIcon="number" let-index="index">
        @if(index === 0) { <img class="step-icon-img" src="assets/excel.jpg" alt="" /> }
        @else if(index === 1) { <img class="step-icon-img" src="assets/upload-doc1.png" alt="" /> }
        @else if(index === 2) { <img class="step-icon-img" src="assets/tag.png" alt="" /> }
        @else { <img class="step-icon-img" src="assets/submit.png" alt="" /> }
      </ng-template>
      <ng-template matStepperIcon="edit" let-index="index">
        @if(index === 0) { <img class="step-icon-img" src="assets/excel.jpg" alt="" /> }
        @else if(index === 1) { <img class="step-icon-img" src="assets/upload-doc1.png" alt="" /> }
        @else if(index === 2) { <img class="step-icon-img" src="assets/tag.png" alt="" /> }
        @else { <img class="step-icon-img" src="assets/submit.png" alt="" /> }
      </ng-template>
      <ng-template matStepperIcon="done" let-index="index">
        @if(index === 0) { <img class="step-icon-img" src="assets/excel.jpg" alt="" /> }
        @else if(index === 1) { <img class="step-icon-img" src="assets/upload-doc1.png" alt="" /> }
        @else if(index === 2) { <img class="step-icon-img" src="assets/tag.png" alt="" /> }
        @else { <img class="step-icon-img" src="assets/submit.png" alt="" /> }
      </ng-template>

      @for (stepKey of bulkStepLabelKeys; track stepKey; let index = $index) {
      <mat-step
        [completed]="(index === 0 && excelImported) || (index === 1 && isPdfUploaded)"
        [editable]="isEditable">

        <ng-template matStepLabel>{{ stepKey | translate }}</ng-template>

        @if(index === 0) {
          <div class="bulk-excel-step">
            <input
              #excelInput
              type="file"
              hidden
              accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              (change)="onExcelSelected($event)" />

            <div class="upload-section-container">
              <div class="upload-section-inner">
                <div
                  class="drag-drop-area"
                  (dragenter)="allowExcelDrop($event)"
                  (dragover)="allowExcelDrop($event)"
                  (drop)="onExcelDrop($event)">
                  <img
                    class="bulk-excel-step__brand-icon"
                    src="assets/excel.jpg"
                    alt="" />
                  <div class="file-upload-title">{{ 'bulkUploadExcelTitle' | translate }}</div>
                  <p class="info-text" [innerHTML]="'bulkUploadExcelHint' | translate"></p>
                  <div class="bulk-excel-step__file-actions">
                    <button mat-stroked-button type="button" class="choose-file-btn" (click)="triggerExcelPick()">
                      {{ 'bulkChooseExcelFile' | translate }}
                    </button>
                    <button
                      mat-button
                      type="button"
                      class="bulk-excel-step__template-btn"
                      [disabled]="isDownloadingTemplate"
                      (click)="downloadSignerTemplate()">
                      <mat-icon>download</mat-icon>
                      {{ 'bulkDownloadSignerTemplate' | translate }}
                    </button>
                  </div>
                  @if (excelFileName) {
                    <div class="upload-area__selected">
                      <mat-icon class="upload-area__check">check_circle</mat-icon>
                      <span class="upload-area__filename">{{ excelFileName }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>

            @if (excelImported && tableService.tableInputData.length) {
              <div class="create-setup__card users-card signer-panel">
                <div class="users-card__header">
                  <span class="users-card__title">
                    <img src="assets/manage_user_icon.png" alt="" class="users-card__title-icon" />
                    {{ 'bulkSignersFromFile' | translate: { count: tableService.tableInputData.length } }}
                  </span>
                </div>
                <div class="users-card__table-scroll">
                  <kzn-table
                    [showSearch]="false"
                    [showPagination]="false"
                    [showOrderColumn]="true"
                    [data]="tableService.tableInputData"
                    [columns]="tableColumns"
                    [rowActions]="tableRowActions"
                    actionColumnHeader="action"
                    style="width:100%">
                  </kzn-table>
                </div>
              </div>
            }

            <div class="create-sign-stepper__actions">
              <button mat-button type="button" class="create-sign-stepper__btn create-sign-stepper__btn--reset" (click)="resetStepper()">
                {{ 'reset' | translate }}
              </button>
              <button mat-raised-button type="button" class="create-sign-stepper__btn create-sign-stepper__btn--next" (click)="nextFromImportStep()">
                {{ 'next' | translate }}
              </button>
            </div>
          </div>
        }

        @else if(index === 1) {
          <app-create-setup-document
            #setupDocRef
            [useCombinedSetupLayout]="false"
            [hideManageUsersSection]="true"
            [showImportedSignersPanel]="true"
            [wizardSetupPhase]="wizardSetupPhase"
            (wizardSetupAdvance)="onSetupAdvance()"
            (wizardSetupGoBack)="onSetupGoBack()"
            (pdfUploaded)="handlePdfUploaded($event)"
            (appTokenUpdated)="handleAppTokenUpdated($event)"
            (onReset)="resetStepper()"
            (onNext)="nextStep()">
          </app-create-setup-document>
        }

        @else if(index === 2) {
          <app-pdf-view-edit
            class="pdf-view-edit-step"
            [pdfFile]="pdfFile"
            [docName]="resolvedDocumentName"
            [appToken]="appToken"
            [fixedToolsLayout]="true"
            (previousStep)="previousStep()"
            (onSubmitComplete)="handleSubmitComplete()"
            [topPosition]="topPosition">
          </app-pdf-view-edit>
        }

        @else {
          <app-pdf-thank-you></app-pdf-thank-you>
        }

      </mat-step>
      }
    </mat-stepper>
  </div>

  @if (stepper?.selectedIndex === 2) {
  <div class="create-sign-stepper__props-backdrop"
       [class.show]="propertiesDrawerOpen"></div>
  <aside class="create-sign-stepper__props-wrapper"
       [class.drawer-open]="propertiesDrawerOpen">
    <div class="create-sign-stepper__props-handle"
         [class.open]="propertiesDrawerOpen"
         (click)="togglePropertiesDrawer()">
      <div class="create-sign-stepper__props-grip"></div>
      <div class="create-sign-stepper__props-title">Property</div>
      <mat-icon class="create-sign-stepper__props-icon">{{ propertiesDrawerOpen ? 'expand_more' : 'expand_less' }}</mat-icon>
    </div>

    <div class="create-sign-stepper__field-actions create-sign-stepper__review-tools-desktop">
      <button mat-stroked-button type="button" class="create-sign-stepper__field-back" (click)="goToPrevious()">
        Back
      </button>
      <button mat-flat-button type="button" color="warn" class="create-sign-stepper__field-submit" (click)="submitData()">
        Submit
      </button>
    </div>

    <div class="create-sign-stepper__props-body">
    <div class="create-sign-stepper__tools-stack create-sign-stepper__review-tools-desktop">
      <div class="create-sign-stepper__tools-card">
        <div class="create-sign-stepper__tools-inner">
          <div class="create-sign-stepper__panel-hint create-sign-stepper__tools-hint">
            <div class="create-sign-stepper__panel-hint-brand">
              <div class="circle-hint"><img src="assets/hint.png" class="hint-icon" alt="Hint"></div>
              <span class="create-sign-stepper__panel-hint-title">Tools</span>
            </div>
            <p>Choose a tool and click or drag onto the document.</p>
          </div>
          <div class="create-sign-stepper__tools-grid" [attr.data-tools-revision]="tableService.tableInputDataRevision">
            @for (tool of fieldTools; track tool.id) {
              <div
                role="button"
                tabindex="0"
                class="create-sign-stepper__tool"
                [class.create-sign-stepper__tool--active]="pdfEditState.selectedTool() === tool.id"
                [class.create-sign-stepper__tool--dragging]="pdfViewEditComponent.draggingToolId === tool.id"
                [class.create-sign-stepper__tool--disabled]="isToolDisabled(tool)"
                [attr.aria-disabled]="isToolDisabled(tool)"
                [attr.draggable]="!isToolDisabled(tool)"
                (click)="pdfViewEditComponent.onToolClick(tool.id, $event)"
                (keydown.enter)="pdfViewEditComponent.onToolClick(tool.id, $event)"
                (keydown.space)="pdfViewEditComponent.onToolClick(tool.id, $event); $event.preventDefault()"
                (dragstart)="pdfViewEditComponent.onToolDragStart($event, tool.id)"
                (dragend)="pdfViewEditComponent.onToolDragEnd()">
                <mat-icon>{{ tool.icon }}</mat-icon>
                <span>{{ tool.label }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <mat-card class="create-sign-stepper__props-panel"
      [class.drawer-open]="propertiesDrawerOpen">
      <div class="create-sign-stepper__panel-hint create-sign-stepper__props-hint-banner">
        <div class="create-sign-stepper__panel-hint-brand">
          <div class="circle-hint"><img src="assets/hint.png" class="hint-icon" alt="Hint"></div>
          <span class="create-sign-stepper__panel-hint-title">Property</span>
        </div>
        <p>Click a document field to customize its settings.</p>
      </div>
      <mat-card-content class="create-sign-stepper__props-content">
        @if (displayedPropertyAnnotation; as ann) {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Field Name</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <input matInput id="bulk-placeholder" #bulkPlaceholderEl [ngModel]="ann.properties.placeholder"
              (input)="pdfEditState.updateAnnotationProperty('placeholder', bulkPlaceholderEl.value)" />
          </mat-form-field>
        </div>

        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Font Size</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select [ngModel]="ann.properties.fontSize"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('fontSize', $event)">
              @for (size of fontSizes; track size) {
              <mat-option [value]="size">{{ size }} px</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Assign to</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select [ngModel]="ann.properties.user"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('user', $event)">
              @for (user of tableService.tableInputData; track user.tempID) {
              <mat-option [value]="user.email">{{ user.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (ann.type === 'text' || ann.type === 'comment' || ann.type === 'initials') {
        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">{{ 'fieldColor' | translate }}</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select
              [ngModel]="ann.properties['signatureColor'] || '#000000'"
              (ngModelChange)="pdfEditState.updateAnnotationProperty('signatureColor', $event)">
              @for (color of selfSignSignatureColors; track color.id) {
              <mat-option [value]="color.value">
                <span class="create-sign-stepper__color-option">
                  <span class="create-sign-stepper__color-dot" [style.background-color]="color.value"></span>
                  {{ color.labelKey | translate }}
                </span>
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }

        <div class="create-sign-stepper__props-field-group">
          <span class="create-sign-stepper__props-label">Copy to</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic"
            class="create-sign-stepper__props-field" (click)="$event.stopPropagation()">
            <mat-select placeholder="Select" (selectionChange)="pdfEditState.copyAnnotationToPages($event.value)">
              <mat-option value="all">All Pages</mat-option>
              <mat-option value="even">Even Pages</mat-option>
              <mat-option value="odd">Odd Pages</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        }
      </mat-card-content>
    </mat-card>
    </div>
  </aside>
  }
</div>
